module.exports = "/assets/dist/images/bodystyles_wagons_sm.png?096012b7885dd6da7b127ddba14cca52";